<template>
  <div class="component-body flex">
    <el-input-number v-model="num" @change="handleChange" :min="1" :max="10" label="描述文字"></el-input-number>
    <el-input-number class="margin-left-10" v-model="num" @change="handleChange" :min="1" :max="10" label="描述文字"
                     disabled></el-input-number>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      num: 1
    }
  },
  methods: {
    handleChange (value) {
      // console.log(value)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/7/InputNumber/index.vue